// useProductsData.js
import { useEffect, useState } from 'react';
import { BEARER_TOKEN } from '../../src/store/config';
import axios from 'axios';

export interface Product {
  productId: number;
  productName: string;
  imageName: string;
  price: number;
  activationPoints: number;
  networkPoints: number;
  discount: number;
}

const useProductsData = (pageNumber: number = 1, pageSize: number = 1000) => {
  const [dataProducts, setDataProducts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          "https://api.yosoymitzen.com/v1/Product/GetProductsStore",
          {
            number: pageNumber,
            size: pageSize
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${BEARER_TOKEN}`
            },
          }
        );
        if (response.data.message === "Success") {
          setDataProducts(response.data.data.productStore);
        } else {
          console.error("Error al consumir el servicio GetProductsStore");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [pageNumber, pageSize]);

  const newArrayFormat: Product[] = dataProducts.map((product) => ({
    productId: product.productId,
    productName: product.productName,
    imageName: product.imageName,
    price: product.price,
    activationPoints: product.activationPoints,
    networkPoints: product.networkPoints,
    discount: product.discount
  }));

  return newArrayFormat;
};

export default useProductsData;